export default "/wp-content/themes/onnit/script/cart/dist/o6Kettlebell-3997985b.jpg";